import useLocale from '~/hooks/useLocale'
import { DATE_TIME_FORMAT } from '~/shared/constants/time.const'
import { formatInterval, getTimezoneOffset } from '~/utils/time'
import { getBrowserTimezone } from '~/utils/helpers'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import TimezoneIcon from '~/components/Icons/svgs/TimezoneIcon'
import HomCameraCircleIcon from '~/components/Icons/svgs/HomCameraCircleIcon'

const { DAY_MONTH_WEEKDAY_YEAR } = DATE_TIME_FORMAT

export default function ShiftMinimal({
  startTime,
  endTime,
}: {
  startTime: string
  endTime: string
}): React.ReactElement {
  const locale = useLocale()
  const dateObjStartTime = new Date(startTime)
  const dateObjEndTime = new Date(endTime)
  const dateStr = dateObjStartTime.toLocaleDateString(locale, DAY_MONTH_WEEKDAY_YEAR)

  const timezone = getBrowserTimezone()
  const timezoneOffset = getTimezoneOffset(timezone)

  return (
    <div className="relative p-3 rounded shadow-card bg-white text-xxs">
      <div className="text-md font-semibold text-hotpink">Video Chat</div>
      <span className="block text-xxs font-semibold">Shift</span>
      <span className="flex">{dateStr}</span>
      <span className="flex space-x-1">
        <span>{formatInterval(dateObjStartTime, dateObjEndTime)}</span>
        <span>&sdot;</span>
        <span className="space-x-0.5 flex items-center text-2.5 text-gray-ash">
          <SVGIcon icon={TimezoneIcon} pathClassName="currentColor" size={14} />
          <span>{timezoneOffset}</span>
        </span>
      </span>
      <div className="absolute top-1/2 right-5 transform -translate-y-1/2 filter drop-shadow-xl">
        <SVGIcon icon={HomCameraCircleIcon} size={50} />
      </div>
    </div>
  )
}
